export enum CooperativesActionTypes {
  REQUEST_COOPERATIVES_START = '@@coperatives/REQUEST_COOPERATIVES_START',
  REQUEST_COOPERATIVES_SUCCESS = '@@cooperatives/REQUEST_COOPERATIVES_SUCCESS',
  REQUEST_COOPERATIVES_FAILED = '@@cooperatives/REQUEST_COOPERATIVES_FAILED',
}
